import { render, staticRenderFns } from "./UnscheduledModelDetail.vue?vue&type=template&id=c71224e8&scoped=true"
import script from "./UnscheduledModelDetail.vue?vue&type=script&lang=js"
export * from "./UnscheduledModelDetail.vue?vue&type=script&lang=js"
import style0 from "./UnscheduledModelDetail.vue?vue&type=style&index=0&id=c71224e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c71224e8",
  null
  
)

export default component.exports